import { useState } from "react";
import { DateRangePicker } from "../../shared/dateRangePicker";
import { SearchFiltersModal } from "../../shared/searchFiltersModal";
import stringHelpers from "../../../utilities/stringHelpers";
import { toDateString } from "../../../utilities/dateUtilities";

export const KadoeDataFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialFromDate,
	initialToDate,
	initialAppliedFilters
}) => {
	const [fromDate, setFromDate] = useState(initialFromDate)
	const [toDate, setToDate] = useState(initialToDate)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setFromDate(null)
		setToDate(null)
		setAppliedFilters(null)
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ fromDate, toDate, appliedFilters }) }
			showModal={ showModal }
			key="kadoe-data-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Date Range</label>
					<DateRangePicker
						fromDate={ fromDate }
						toDate={ toDate }
						setDateRange={ (firstDate, lastDate, presetLabel) => {
							const isFirstDateEmpty = firstDate === null || firstDate === ""
							const isLastDateEmpty = lastDate === null || lastDate === ""
							setFromDate(isFirstDateEmpty ? null : firstDate);
							setToDate(isLastDateEmpty ? null : lastDate);
							if (!stringHelpers.isNullOrEmpty(presetLabel)) {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters.From
									delete updatedFilters.To
									updatedFilters["Date Range"] = presetLabel
									return updatedFilters
								})
							}
							else {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (!isFirstDateEmpty && !isLastDateEmpty) {
										delete updatedFilters.From
										delete updatedFilters.To
										updatedFilters["Date Range"] = `${toDateString(new Date(firstDate))} - ${toDateString(new Date(lastDate))}`
									} else {
										if (!isFirstDateEmpty) {
											updatedFilters.From = toDateString(new Date(firstDate))
										} else {
											delete updatedFilters.From
										}
										if (!isLastDateEmpty) {
											updatedFilters.To = toDateString(new Date(lastDate))
										} else {
											delete updatedFilters.To
										}
										delete updatedFilters["Date Range"]
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						}}
						showClearOption
						hideLabel
						fullWidth
						dropdownPositionRight
					/>
				</div>
			</div>
		</SearchFiltersModal>
	)
}
